import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, Calendar, ArrowRight } from 'lucide-react';

// Session storage key for one-time event firing
const LEAD_EVENT_FIRED_KEY = 'glow_event_fired_EligibilityLead';

const EligibilityConfirmed = () => {
  // Fire Meta Pixel Lead event on page load (once per session)
  useEffect(() => {
    // Check if already fired this session
    if (sessionStorage.getItem(LEAD_EVENT_FIRED_KEY)) {
      console.log('[Tracking] EligibilityLead already fired this session, skipping');
      return;
    }

    // Fire Meta Pixel Lead event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Eligibility Call Booked',
        content_category: 'Eligibility',
        source: 'eligibility_confirmed_page'
      });
      console.log('[Meta Pixel] Fired: Lead (Eligibility Call Booked)');
    }

    // Fire Google Ads event
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'lead', {
        content_name: 'Eligibility Call Booked',
        content_category: 'Eligibility',
        source: 'eligibility_confirmed_page'
      });
    }

    // Mark as fired for this session
    sessionStorage.setItem(LEAD_EVENT_FIRED_KEY, 'true');
  }, []);

  return (
    <div className="page-eligibility-confirmed">
      <div className="confirmed-container">
        <div className="confirmed-content">
          {/* Success Icon */}
          <div className="confirmed-icon">
            <Check size={40} />
          </div>

          {/* Main Heading */}
          <h1 className="confirmed-title">You're All Set!</h1>
          
          <p className="confirmed-subtitle">
            Your eligibility call has been scheduled. We're looking forward to speaking with you.
          </p>

          {/* Info Card */}
          <div className="confirmed-info-card">
            <div className="info-card-header">
              <Calendar size={20} />
              <span>What to Expect</span>
            </div>
            <ul className="info-card-list">
              <li>A brief 10-minute call to review your assessment</li>
              <li>Answer any questions you have about our care model</li>
              <li>Determine if personalized hormone care is right for you</li>
            </ul>
            <p className="info-card-note">
              <strong>Note:</strong> This is not a medical visit. No diagnosis or treatment will be provided on this call.
            </p>
          </div>

          {/* Next Steps */}
          <div className="confirmed-next-steps">
            <p className="next-steps-text">
              Check your email for a calendar invite with meeting details.
            </p>
          </div>

          {/* CTA */}
          <div className="confirmed-actions">
            <Link to="/" className="btn-confirmed-primary">
              Return to Home
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EligibilityConfirmed;
